export default "__VITE_ASSET__CMX4awv6__"